var chunkMapping = {
	"0": [
		4699,
		4310
	],
	"74": [
		5101
	],
	"153": [
		5180
	],
	"154": [
		5181
	],
	"157": [
		5184
	],
	"158": [
		5185
	],
	"159": [
		5186
	],
	"160": [
		5187
	],
	"161": [
		5188
	],
	"162": [
		5189
	],
	"163": [
		5190
	],
	"164": [
		5191
	],
	"165": [
		5192
	],
	"166": [
		5193
	],
	"167": [
		5194
	],
	"168": [
		5195
	],
	"169": [
		5196
	],
	"170": [
		5197
	],
	"171": [
		5198
	],
	"172": [
		5199
	],
	"173": [
		5200
	]
};
var idToExternalAndNameMapping = {
	"4310": [
		"default",
		"./nuorder-components",
		4110
	],
	"4699": [
		"default",
		"./Containers",
		3795
	],
	"5101": [
		"default",
		"./OrderlessInvoices",
		3795
	],
	"5180": [
		"default",
		"./AsyncEventTracker",
		3795
	],
	"5181": [
		"default",
		"./HostWrapper",
		3795
	],
	"5184": [
		"default",
		"./CheckoutV3",
		3795
	],
	"5185": [
		"default",
		"./CheckoutConfirmation",
		3795
	],
	"5186": [
		"default",
		"./ContactCreditCards",
		3795
	],
	"5187": [
		"default",
		"./AuditDialog",
		3795
	],
	"5188": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3795
	],
	"5189": [
		"default",
		"./InvoiceDialog",
		3795
	],
	"5190": [
		"default",
		"./PaymentDueModal",
		3795
	],
	"5191": [
		"default",
		"./PaymentModal",
		3795
	],
	"5192": [
		"default",
		"./PaymentHistory",
		3795
	],
	"5193": [
		"default",
		"./PaymentConfigurations",
		3795
	],
	"5194": [
		"default",
		"./PaymentPreferences",
		3795
	],
	"5195": [
		"default",
		"./ManagePaymentProcessing",
		3795
	],
	"5196": [
		"default",
		"./MobilePaymentsWrapper",
		3795
	],
	"5197": [
		"default",
		"./Challenge",
		3795
	],
	"5198": [
		"default",
		"./ManagePaymentMethods",
		3795
	],
	"5199": [
		"default",
		"./LightspeedReports",
		3795
	],
	"5200": [
		"default",
		"./ShippingPromotionsListContainer",
		3795
	]
};
var idToRemoteMap = {
	"4310": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 4110
		}
	],
	"4699": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5101": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5180": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5181": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5184": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5185": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5186": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5187": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5188": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5189": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5190": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5191": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5192": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5193": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5194": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5195": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5196": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5197": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5198": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5199": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5200": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}